import { useCallback } from "react";
import {
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuCheckboxItem,
  DropdownMenuItem,
  DropdownMenuIcon,
} from "@/components/ui/dropdown-menu";
import { BooleanFilterMenuItemType } from "../FilterMenu.model";
import { isNullFilter } from "../FieldFilter.model";

interface BooleanFilterMenuItemProps<Field extends string>
  extends BooleanFilterMenuItemType<Field> {
  onChange: (item: BooleanFilterMenuItemType<Field>) => void;
}

export function BooleanFilterMenuItem<Field extends string>({
  onChange,
  ...item
}: BooleanFilterMenuItemProps<Field>) {
  const handleBooleanClick = useCallback(
    (value: boolean) => {
      onChange({
        ...item,
        value: {
          operator: "eq",
          value,
        },
      });
    },
    [item, onChange]
  );

  const handleClear = useCallback(() => {
    onChange({
      ...item,
      value: undefined,
    });
  }, [item, onChange]);

  const trueLabel = item.trueLabel ?? "Yes";
  const falseLabel = item.falseLabel ?? "No";

  if (item.value?.value == null) {
    return (
      <DropdownMenuSub>
        <DropdownMenuSubTrigger>
          {item.icon && <DropdownMenuIcon>{item.icon}</DropdownMenuIcon>}
          {item.label}
        </DropdownMenuSubTrigger>
        <DropdownMenuSubContent sideOffset={8} alignOffset={-5}>
          <DropdownMenuItem onClick={() => handleBooleanClick(true)}>
            {trueLabel}
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => handleBooleanClick(false)}>
            {falseLabel}
          </DropdownMenuItem>
        </DropdownMenuSubContent>
      </DropdownMenuSub>
    );
  }

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        {item.icon && <DropdownMenuIcon>{item.icon}</DropdownMenuIcon>}
        {item.label}
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent sideOffset={8} alignOffset={-5}>
        <DropdownMenuCheckboxItem
          checked={item.value?.value === true}
          onCheckedChange={() => handleBooleanClick(true)}
        >
          {trueLabel}
        </DropdownMenuCheckboxItem>
        <DropdownMenuCheckboxItem
          checked={item.value?.value === false}
          onCheckedChange={() => handleBooleanClick(false)}
        >
          {falseLabel}
        </DropdownMenuCheckboxItem>
        <DropdownMenuItem onClick={handleClear}>Clear</DropdownMenuItem>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
}
